import { render, staticRenderFns } from "./DesignTeam.vue?vue&type=template&id=2577f056&scoped=true&"
import script from "./DesignTeam.vue?vue&type=script&lang=js&"
export * from "./DesignTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2577f056",
  null
  
)

export default component.exports